import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";

import styled from "styled-components/macro";

import { faUserEdit } from "@fortawesome/pro-solid-svg-icons";
import API from "Signups/API";
import { signupItemStateHooks } from "Signups/SignupView/SignupSheet/Screens/SignupItems/stateHooks";
import { useGetSignupListType } from "Signups/SignupView/utils/useGetSignupListType";
import { useSignups } from "Signups/state";

import FnrLoadingBricks from "UI/FnrLoadingBricks";

import AddHouseholdMemberEntry from "./AddHouseholdMemberEntry";
import { User } from "./Styles";
import {
  getNumberOfItemSlotsRemaining,
  getNumberOfPersonSlotsRemaining,
} from "./checkForAvailableSlots";
import { checkHouseholdForCurrentSignups } from "./checkHouseholdForCurrentSignups";

export default function AddHouseholdMemberPopover({
  show,
  householdID,
  signupItemID,
  handleSomeoneElseClick,
  closePopover,
}) {
  const [state] = useSignups();
  const [status, setStatus] = useState(null);
  const [household, setHousehold] = useState([]);
  const { isMemberType, isPollType } = useGetSignupListType();
  const { signupItem } = signupItemStateHooks.useCurrentSignupItem();

  const isItemSlotAvailable = getNumberOfItemSlotsRemaining(signupItem) > 0;
  const isPersonSlotAvailable =
    getNumberOfPersonSlotsRemaining(null, householdID, signupItem) > 0;

  const itemIsFull =
    !isPollType && (!isPersonSlotAvailable || !isItemSlotAvailable);

  useEffect(() => {
    if (show) {
      API.getHouseholdUsers({
        signupListID: state.currentSignupList.ID,
        householdID,
      })
        .post()
        .then((responseData) => {
          const newHouseholdData = checkHouseholdForCurrentSignups({
            household: responseData.household,
            userSignupItems: responseData.userSignupItems,
            signupItemID,
            allowMultipleItemSignups:
              state.currentSignupList.options.allowMultipleItemSignups,
          });
          setHousehold(newHouseholdData);
          setStatus("fetchSuccess");
        })
        .catch((err) => {
          console.log("err", err);
          setStatus("fetchError");
        });
    }
  }, [
    show,
    state.currentSignupList.ID,
    householdID,
    signupItemID,
    state.currentSignupList.options.allowMultipleItemSignups,
  ]);

  const renderSomeoneElseButton = () => {
    // Only member-type signups should allow additionalNames to be added
    if (!isMemberType) return null;

    return (
      <SomeoneElse role="button" onClick={handleSomeoneElseClick}>
        <FontAwesomeIcon icon={faUserEdit} />
        Someone else...
      </SomeoneElse>
    );
  };

  if (itemIsFull) {
    return (
      <Wrapper>
        <ItemFull>
          This item is currently full. To add a member, please increase the
          number of available slots.
        </ItemFull>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      {status === "loading" ? (
        <LoadingWrapper>
          <FnrLoadingBricks show color="gray" size={32} />
        </LoadingWrapper>
      ) : null}

      {status === "fetchSuccess" ? (
        <>
          {household.map((user) => (
            <AddHouseholdMemberEntry
              key={user.userID}
              user={user}
              signupItemID={signupItemID}
              closePopover={closePopover}
            />
          ))}

          {household.length < 1 ? (
            <NoMembers>No household members found.</NoMembers>
          ) : null}

          {renderSomeoneElseButton()}
        </>
      ) : null}

      {status === "fetchError" ? (
        <>
          <Error>
            Oh no! There was a problem getting the list of household members.
          </Error>
          {renderSomeoneElseButton()}
        </>
      ) : null}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  min-height: 50px;
  max-width: 260px;
  max-height: 400px;
`;

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  height: 50px;
`;

const NoMembers = styled.div`
  padding: 5px;
  opacity: 0.7;
`;

const SomeoneElse = styled(User)`
  font-style: italic;
  svg {
    margin-right: 4px;
  }
`;

const Error = styled.div`
  padding: 5px;
  opacity: 0.7;
`;

const ItemFull = styled.div`
  padding: 5px;
  font-size: 15px;
`;
